/*
 * Returns if a value is a string
 *
 * @param {String} - Value to parse
 * @return {Boolean} - Result if value is string
 */
const isString = value => typeof value === 'string' || value instanceof String;

/*
 * Returns if a value is really a number
 *
 * @param {Number} - Value to parse
 * @return {Boolean} - Result if value is number
 */
const isNumber = value => typeof value === 'number' && isFinite(value); // eslint-disable-line

/*
 * Returns if a value is an array
 *
 * @param {Array} - Value to parse
 * @return {Boolean} - Result if value is array
 */
const isArray = value => value && Array.isArray(value);

/*
 * Returns if a value is an object
 *
 * @param {Object} - Value to parse
 * @return {Boolean} - Result if value is object
 */
const isObject = value => value && typeof value === 'object';

/*
 * Returns if a value is null
 *
 * @param {Null} - Value to parse
 * @return {Boolean} - Result if value is null
 */
const isNull = value => value === null;

/*
 * Returns if a value is undefined
 *
 * @param {String} - Value to parse
 * @return {Boolean} - Result if value is undefined
 */
const isUndefined = value => typeof value === 'undefined';

/*
 * Returns if a value is a boolean
 *
 * @param {Booelan} - Value to parse
 * @return {Boolean} - Result if value is boolean
 */
const isBoolean = value => typeof value === 'boolean';

/*
 * Returns if value is a dat
 *
 * @param {Date} - Value to parse
 * @return {Boolean} - Result if value is date
 */
const isDate = value => value instanceof Date;

/**
 * Comprueba si un objeto contiene una propiedad
 *
 * @param {Object} - Objecto que queremos comprobar
 * @param {String} - Propiedad que queremos buscar
 * @return {Boolean} - Devuelve si la propiedad existe o no
 */
const hasProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

/* prettier-ignore */
export {
  isString,
  isNumber,
  isArray,
  isObject,
  isNull,
  isUndefined,
  isBoolean,
  isDate,
  hasProp,
};
